import AsyncForm from '../../form/js/async-form.component';
import TimelineLite from 'gsap/TimelineLite';
import BaseComponent from '../../../general/js/base-component';
import defaultTemplate from '../html/default-template.hbs';

export default class FormResultReplacer extends BaseComponent {
    constructor() {
        super(...arguments);

        this.isResultShown = false;

        // form element for AsyncForm
        this.formElement = this.element.querySelector('.js-form-result-replacer-form');
        // element for "thank you message" inserting
        this.resultElement = this.element.querySelector('.js-form-result-replacer-result');
        //optional container in case we want to hide not only formElement but its parent or sibling
        this.replaceElement = this.element.querySelector('.js-form-result-replacer-replace');

        if (this.formElement && this.resultElement) {
            this.init();
        } else {
            throw new Error('formElement and resultElement are not specified');
        }
    }

    init() {
        this.resultElement.style.display = 'none';
        this.formComponent = this.createFormInstance();
    }

    createFormInstance() {
        return new AsyncForm(this.formElement, {props: {onSuccess: this.onFormSuccess.bind(this)}});
    }

    onFormSuccess(result) {
        if (this.isResultShown) {
            return;
        }

        let hideElements = [this.formElement];
        if (this.replaceElement) {
            hideElements.push(this.replaceElement);
        }

        this.tween = new TimelineLite({paused: true});
        this.tween.to(hideElements, 0.5, {opacity: 0, display: 'none'});
        this.tween.to(this.resultElement, 0.5, {opacity: 1, display: 'block'});
        this.tween.play();

        this.resultElement.innerHTML = this.getMessage(result);
        this.isResultShown = true;
    }

    getMessage(result) {
        return defaultTemplate(result);
    }
}



// WEBPACK FOOTER //
// ./app/components/form-result-replacer/js/form-result-replacer.component.js